import { NoDataContentWrapper, RenderDataWithFallback, NoDataContentWrapperProps } from '@anytag/shared-atoms';
import { SectionWithHeader, SectionWithHeaderProps } from '@anytag/shared-molecules';

export interface AnalyticsFeedPostsWrapperProps
  extends SectionWithHeaderProps,
    Pick<NoDataContentWrapperProps, 'dataNotAvailable'> {
  loading?: boolean;
}

export const AnalyticsFeedPostsWrapper = ({
  loading,
  children,
  dataNotAvailable,
  moreDetailProps,
  ...restProps
}: AnalyticsFeedPostsWrapperProps) => (
  <RenderDataWithFallback loading={loading}>
    <SectionWithHeader
      moreDetailProps={!dataNotAvailable ? moreDetailProps : undefined}
      css={{ borderRadius: 0, marginTop: '1px', minHeight: '200px', '.section-header': { borderBottom: 'none' } }}
      {...restProps}
    >
      <NoDataContentWrapper dataNotAvailable={dataNotAvailable} className="no-data-wrapper min-h-30 border-none">
        {children}
      </NoDataContentWrapper>
    </SectionWithHeader>
  </RenderDataWithFallback>
);
